var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
var FocusedDropDownSearch = (function (_super) {
    __extends(FocusedDropDownSearch, _super);
    function FocusedDropDownSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.searchRef = React.createRef();
        return _this;
    }
    FocusedDropDownSearch.prototype.componentDidMount = function () {
        if (this.searchRef && this.searchRef.current) {
            this.searchRef.current.focus();
        }
    };
    FocusedDropDownSearch.prototype.onClick = function (event) {
        event.stopPropagation();
    };
    FocusedDropDownSearch.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, onChange = _a.onChange, placeholder = _a.placeholder;
        return (React.createElement("input", { ref: this.searchRef, onClick: onClick ? onClick : this.onClick, onChange: onChange, placeholder: placeholder, className: css(styles.search), autoComplete: "off" }));
    };
    return FocusedDropDownSearch;
}(React.Component));
export { FocusedDropDownSearch };
var styles = StyleSheet.create({
    search: {
        'font-family': '\'TrustpilotDefaultFont\', Arial, sans-serif',
        'fontSize': '16px',
        'padding': '15px',
        'display': 'inline-block',
        'background': 'none',
        'outline': 'none',
        'border': 'none',
        'width': '100%',
        '::placeholder': {
            color: '#D6D6D6',
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/CommonUI/Controls/FocusedDropDownSearch.js
// module id = 1270
// module chunks = 0